
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";

interface DeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  deleteAllData: boolean;
  onDeleteDataChange: (value: boolean) => void;
}

export function DeleteDialog({
  open,
  onOpenChange,
  onConfirm,
  deleteAllData,
  onDeleteDataChange
}: DeleteDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Subscriber</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to permanently delete this subscriber and all associated data? 
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex items-center space-x-2 mb-4 py-2">
          <input
            type="checkbox"
            id="removeData"
            checked={deleteAllData}
            onChange={(e) => onDeleteDataChange(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
          />
          <label htmlFor="removeData" className="text-sm">
            Also remove all subscriber data (message history, notifications)
          </label>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>No, keep subscriber</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700">
            Yes, delete subscriber
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
